export default __webpack_public_path__ + "static/media/paypal.e41d02fa.png";